import AccountHead from "./AccountHead/";
import DayBook from "./DayBook";
import Groups from "./Groups";
import LedgerBook from "./LedgerBook";
import PartyRate from "./PartyRate";
import RouteDetails from "./RouteDetails";

export default {
  AccountHead,
  Groups,
  DayBook,
  LedgerBook,
  PartyRate,
  RouteDetails,
};
